import { Link } from 'react-router-dom';
import searchIcon from './search-icon.svg';
import styled, { createGlobalStyle } from 'styled-components';

export const Contributions = styled.div`
	width: 100%;
	max-width: 760px;
	margin: 50px auto;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: sticky;
	top: 30px;
	width: 100%;
	height: 50px;
	box-shadow: 0 3px 6px 0 rgb(0 0 0 / 5%);
	background-color: #fff;
`;

export const SortBy = styled.div`
	display: flex;
	align-items: center;
	margin-left: 10px;
`;

export const SortByLabel = styled.label`
	margin-right: 10px;
	font-weight: 500;
	font-size: 0.9rem;
	text-transform: uppercase;
	color: rgba(0, 0, 0, .5);
`;

export const SearchContainer = styled.div`
	position: relative;
	width: 33%;
	min-width: 250px;
	max-width: 500px;
	&:after {
		content: '';
		position: absolute;
		top: 3px;
		right: 0;
		display: inline-block;
		width: 16px;
		height: 16px;
		background: url(${searchIcon});
		background-size: 16px 16px;
	}
`;

export const SearchInput = styled.input`
	width: 100%;
	border: 0;
	font-weight: 500;
	font-size: 1rem;
	padding-bottom: 5px;
	border-bottom: 2px solid #1d1d1d;
	color: #1d1d1d;
	outline: 0;
	&::placeholder {
		color: #1d1d1d;
	}
`;

interface ButtonLinkProps {
	tall?: boolean
}

export const ButtonLink = styled(Link)<ButtonLinkProps>`
	margin-right: 10px;
	padding: ${(props) => props.tall ? '12px 30px' : '7px 30px'};
	border: 2px solid #fff;
	border-radius: 4px;
	font-weight: 500;
	font-size: ${(props) => props.tall ? '1rem' : '0.9rem'};
	color: #fff;
	text-decoration: none;
	background-color: #000;
`;

export const NotFoundContainer = styled.div`
	margin-top: 100px;
	text-align: center;
`;

export const NotFoundTitle = styled.h2`
	margin-bottom: 2em;
	line-height: 1.4;
	font-size: 1.6rem;
	font-weight: 700;
`;

export const GlobalStyle = createGlobalStyle`
	.wrap {
		margin: 0;
	}
	.rg-dropdown__input {
		width: 100%;
		input {
			width: 100% !important;
		}
	}
`;
